import * as types from "./ActionTypes";
import * as hourUtilizationApi from "../../apis/revshare/HourUtilizationApi";
import { addActiveApiCall } from "./ActiveApiActions";

export function saveHourUtilizationRequestSuccess(hourUtilizationRequest) {
  return { type: types.SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS, hourUtilizationRequest };
}

export function loadHourUtilizationRequestSuccess(hourUtilizationRequests) {
  return { type: types.LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS, hourUtilizationRequests };
}

export function updateHourUtilizationRequestSuccess(updatedRequest) {
  return { type: types.UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS, updatedRequest };
}

export function cancelHourUtilizationRequestSuccess(canceledRequest) {
  return { type: types.CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS, canceledRequest };
}

export function acceptHourUtilizationRequestSuccess(acceptedRequest) {
  return { type: types.ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS, acceptedRequest };
}

export function saveRateAgnosticHourUtilizationRequestSuccess(hourUtilizationRequests) {
  return {
    type: types.SAVE_RATE_AGNOSTIC_HOUR_UTILIZATION_REQUEST_SUCCESS,
    hourUtilizationRequests,
  };
}

export function saveHourUtilizationRequest(hourUtilizationRequest, isAdmin = false, userId = null) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .requestHourUtilization(hourUtilizationRequest, isAdmin, userId)
      .then((hourUtilizationRequest) => {
        dispatch(saveHourUtilizationRequestSuccess(hourUtilizationRequest));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadHourUtilizationRequest(isAdmin = false, userId = null) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .getHourUtilizationRequests(isAdmin, userId)
      .then((hourUtilizationRequests) => {
        dispatch(loadHourUtilizationRequestSuccess(hourUtilizationRequests));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function updateHourUtilizationRequest(requestId, updatedRequest) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .updateHourUtilizationRequest(requestId, updatedRequest)
      .then((updatedRequest) => {
        dispatch(updateHourUtilizationRequestSuccess(updatedRequest));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function cancelHourUtilizationRequest(requestId) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .cancelHourUtilizationRequest(requestId)
      .then((canceledRequest) => {
        dispatch(cancelHourUtilizationRequestSuccess(canceledRequest));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function acceptHourUtilizationRequest(requestId, paidDate) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .acceptHourUtilizationRequest(requestId, paidDate)
      .then((acceptedRequest) => {
        dispatch(acceptHourUtilizationRequestSuccess(acceptedRequest));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function saveRateAgnosticHourUtilizationRequest(valueRequested, consultantId = null) {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.SAVE_RATE_AGNOSTIC_HOUR_UTILIZATION_REQUEST_SUCCESS));
    return hourUtilizationApi
      .requestRateAgnosticHourUtilization(valueRequested, consultantId)
      .then((requests) => dispatch(saveRateAgnosticHourUtilizationRequestSuccess(requests)))
      .catch((error) => {
        throw error;
      });
  };
}
